import { useQuery } from '@tanstack/react-query';
import axios from 'axios'
// import api from '../axiosInterceptor.js'
import qs from 'qs';
const baseUrl = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL
// console.log(baseUrl)
const fetcher = async ({ queryKey }) => {
    // console.log('BASE URL: ', baseUrl, queryKey[0])
    const [url] = queryKey
    const [data, filter, date1, date2] = queryKey[1]; // Extract arguments from queryKey
    // console.log("URL: ", url)
    const tkn = sessionStorage.getItem('urtkn');
    const location = localStorage.getItem('usrlctn');

    let paramData = { ...data, location: location };

    if (date1 && date2) {
        paramData = {
            location: location,
            [filter]: data, // This part might need adjustment based on how `filter` and `data` are truly used.
            startDateStr: date1,
            endDateStr: date2,
        };
    }

    const response = await axios.get(`${baseUrl}/api/${url}`, {
        headers: { Authorization: `Bearer ${tkn}` },
        params: paramData,
        paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false });
        },
    });
    // console.log("RESPONSE: ", response)
    return response.data;
};

export const useGetData = (url, data, filter, date1, date2, options) => {
    console.log('IN GET DATA', url, data, filter)
    // The queryKey uniquely identifies your query.
    // Changes to any part of the array will trigger a refetch.
    return useQuery({
        queryKey: [url, [data, filter, date1, date2]],
        queryFn: fetcher,
        ...options, // Allows overriding default React Query options
    });
};